export default "assets/images/icons/chevron-7bbbb854.svg";